import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

export const QueryProvider = ({ children }: { children: React.ReactNode }) => {
	const [client] = React.useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						refetchOnWindowFocus: false,
					},
				},
			}),
	);

	return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};
